import {
  Button,
  InputBox,
  ContentLayout,
  Content,
  RadioBox,
  TextAreaBox,
  StarRating,
} from "@adminComponents";
import React, {useEffect, useState} from "react";
import styles from "./style.module.scss";
import {useAdminNav} from "@hook";
import {adminApi, constant} from "@utils";
import * as Datas from "@adminData";
import {AdminScreenId} from "@assets";
import moment from "moment";

export default function Page() {
  const {navigate, getParams} = useAdminNav();
  const {no} = getParams<{no?: number}>();
  const [detail, setDetail] = useState<Datas.IReview>({
    star: 5,
  });

  const isEdit = !!detail.no;

  async function getDetail() {
    try {
      if (!no) {
        return;
      }

      const {data, success, message} = await adminApi.review.getDetail({no});
      if (success) {
        setDetail(data);
      } else {
        alert(message || "오류가 발생했습니다");
      }
    } catch (error) {
      console.error("getDetail error", error);
    }
  }

  async function write() {
    try {
      if (
        !detail.name ||
        !detail.product_name ||
        !detail.review_date ||
        !detail.star ||
        !detail.content
      ) {
        alert("모든 데이터를 입력해주세요.");
        throw Error("필수값 누락");
      }
      const {success, data, message} = await adminApi.review.write({
        ...detail,
      });
      if (success) {
        navigate({
          url: AdminScreenId.REVIEW_LIST,
          params: {no: data?.no},
        });
      } else {
        alert(message);
      }
    } catch (error) {
      console.error("write error", error);
    }
  }

  async function edit() {
    try {
      if (
        !detail.name ||
        !detail.product_name ||
        !detail.review_date ||
        !detail.star ||
        !detail.content
      ) {
        alert("모든 데이터를 입력해주세요.");
        throw Error("필수값 누락");
      }
      const {success, message} = await adminApi.review.edit({
        ...detail,
        no: detail.no,
      });
      alert(message);

      if (success) {
        navigate({url: AdminScreenId.REVIEW_LIST});
      }
    } catch (error) {
      console.error("edit error", error);
    }
  }

  async function deleteData() {
    try {
      if (!detail.no) {
        return;
      }
      if (!confirm("삭제하시겠습니까?")) {
        return;
      }
      const {success, message} = await adminApi.review.delete({
        no: detail.no,
      });
      alert(message);
      if (success) {
        navigate({url: AdminScreenId.REVIEW_LIST});
      }
    } catch (error) {
      console.error("edit error", error);
    }
  }

  useEffect(() => {
    getDetail();
  }, [no]);

  return (
    <>
      <ContentLayout title="리뷰 상세">
        <Content>
          <div className={styles.content}>
            <div className="row">
              <div className="col title">성명</div>
              <div className="col">
                <InputBox
                  value={detail?.name}
                  onValue={value => {
                    setDetail({...detail, name: value});
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
            <div className="row">
              <div className="col title">날짜</div>
              <div className="col">
                <InputBox
                  type="date"
                  value={
                    detail?.review_date
                      ? moment(detail?.review_date).format("YYYY-MM-DD")
                      : ""
                  }
                  onValue={value => {
                    setDetail({...detail, review_date: moment(value).toDate()});
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
            <div className="row">
              <div className="col title">상품명</div>
              <div className="col">
                <RadioBox
                  list={[
                    ...constant.PRODUCT_NAME.map(item => ({
                      label: item.title,
                      value: item.title,
                    })),
                  ]}
                  value={String(detail?.product_name)}
                  setValue={value =>
                    setDetail({...detail, product_name: value})
                  }
                />
              </div>
            </div>
            <div className="row">
              <div className="col title">별점</div>
              <div className="col">
                <StarRating
                  initialValue={detail?.star}
                  onChange={value => {
                    setDetail({...detail, star: Number(value)});
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col title">내용</div>
              <div className="col">
                <TextAreaBox
                  value={detail?.content}
                  onValue={value => {
                    setDetail({...detail, content: value});
                  }}
                  boxStyle={{flex: 1, height: 300}}
                />
              </div>
            </div>
          </div>
        </Content>
        <div className={styles.bottomSection}>
          {isEdit ? (
            <>
              <div>
                <Button
                  backgroundColor="#d9d9d9"
                  fontSize={18}
                  paddingHorizontal={39}
                  paddingVertical={12}
                  text={"삭제"}
                  onClick={deleteData}
                />
              </div>
              <div>
                <Button
                  backgroundColor="#d9d9d9"
                  fontSize={18}
                  paddingHorizontal={39}
                  paddingVertical={12}
                  text={"수정"}
                  onClick={edit}
                />
              </div>
            </>
          ) : (
            <>
              <div>
                <Button
                  backgroundColor="#d9d9d9"
                  fontSize={18}
                  paddingHorizontal={39}
                  paddingVertical={12}
                  text={"등록"}
                  onClick={write}
                />
              </div>
            </>
          )}
        </div>
      </ContentLayout>
    </>
  );
}
